<template>
  <div class="warmup-container">
    <img class="spinner-animate" src="@/assets/images/2025/spinner-animate.svg" alt="spinner-animate" />
    <img
      id="global-loader-img"
      class="sprout-leaf-logo"
      data-testid="global-loader-img"
      src="@/assets/images/2025/sprout-leaf-logo.svg"
      alt="sprout-leaf-logo"
    />
  </div>
</template>

<style scoped>
.warmup-container {
  height: 100vh;

  .spinner-animate,
  .sprout-leaf-logo {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .spinner-animate {
    height: 40vh;
    max-height: 500px;
  }

  .sprout-leaf-logo {
    height: 30vh;
    max-height: 400px;
  }
}
</style>
